import { render, staticRenderFns } from "./gateway-contracts.vue?vue&type=template&id=452e9c56&scoped=true&"
import script from "./gateway-contracts.vue?vue&type=script&lang=js&"
export * from "./gateway-contracts.vue?vue&type=script&lang=js&"
import style0 from "./gateway-contracts.vue?vue&type=style&index=0&id=452e9c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e9c56",
  null
  
)

export default component.exports